import React from "react";
import { createPortal } from "react-dom";

import "./payment.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMultiply } from "@fortawesome/free-solid-svg-icons";

import { useShipping } from "../../../contexts/ShippingContext";
import { useOrder } from "../../../contexts/OrderContext";

import { useTheme } from "../../../contexts/ThemeContext";

export default function Payment() {
  const { closePaymentWindow, getPaymentLink } = useShipping();
  const { getAllPrices } = useOrder();
  const { priceAfterDiscounts } = getAllPrices();
  const { theme } = useTheme();

  function handleClose() {
    closePaymentWindow();
  }

  async function handleSubmit() {
    getPaymentLink();
  }

  return createPortal(
    <>
      <div
        className="payment-background"
        onMouseDown={(e) => e.stopPropagation()}
      />
      <div
        className="payment-container"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div
          className="close-button multi-item-mode payment-mode"
          onClick={handleClose}
        >
          <FontAwesomeIcon icon={faMultiply} />
        </div>
        <div
          className={`payment-box ${theme === "light" ? "pay-light-mode" : ""}`}
        >
          <h2 className="payment-text">
            مبلغ قابل پرداخت :
            <span className="payement-text-price">
              {priceAfterDiscounts} تومان
            </span>
          </h2>

          <button
            className="payment-confirm red-submit-btn"
            onClick={handleSubmit}
          >
            پرداخت از طریق درگاه بانکی
          </button>
        </div>
      </div>
    </>,
    document.getElementById("popups")
  );
}
